import CircularProgress from "./CircularProgress";

export default CircularProgress;
export type { CircularProgressProps } from "./CircularProgress.d";
